import alykel from './04_alykel';
import aktirovka from './06_aktirovka';
import arena from './08_arena';
import kvartirniki from './26_kvartirniki';
import otdyh from './10_otdyh';
import otdelnaya from './12_otdelnaya';
import shmidt from './14_shmidt';
import culture from './16_culture';
import skills from './18_skills';
import petushok from './20_petushok';
import mediaschool from './32_mediaschool';
import zapoliarnik from './22_zapoliarnik';
import karier from './24_karier';
import kombinat from './28_kombinat';
import kryshi from './30_kryshi';
import most from './34_most';
import mohnatye from './36_mohnatye';
import museum from './38_museum';
import oganerskaya from './40_oganerskaya';
import dolgoe from './42_dolgoe';
import lama from './44_lama';
import park from './46_park';
import night from './48_night';
import purga from './50_purga';
import sianie from './52_sianie';
import gorodok from './54_gorodok';
import taxi from './56_taxi';
import theatre from './58_theatre';
import naberezh from './60_naberezh';
import holod from './62_holod';

const allBook = [
    alykel,
    aktirovka,
    arena,
    otdyh,
    otdelnaya,
    shmidt,
    culture,
    skills,
    petushok,
    zapoliarnik,
    karier,
    kvartirniki,
    kombinat,
    kryshi,
    mediaschool,
    most,
    mohnatye,
    museum,
    oganerskaya,
    dolgoe,
    lama,
    park,
    night,
    purga,
    sianie,
    gorodok,
    taxi,
    theatre,
    naberezh,
    holod
];

export default allBook;
